import { useCallback, useEffect, useRef } from "react";

export function useCallbackRef<T extends (...args: any[]) => any>(
  callback: T | undefined,
  deps: React.DependencyList = [],
) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  // biome-ignore lint/correctness/useExhaustiveDependencies: Allow pass deps through on this hook
  return useCallback(((...args) => callbackRef.current?.(...args)) as T, deps);
}
